import { useDispatch, useSelector } from 'react-redux';
import { allSectionRights, mainModuleRights } from '../store/User.action';

function EmptyComponent() {
  return null;
}
const TransparentComponent = ({ children }) => children;

export const useComponent = () => {
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const dispatch = useDispatch();
  const {
    UserDetails: { userInfo },
  } = devOrderReducer;

  const checkSwitchStatus = (userRights, section) => {
    let updated = [];
    updated = userRights.length ? userRights.map((ele) => ele?.rights?.[section] && ele.rights[section][0]?.section?.switchStatus) : [];
    return updated;
  };

  const isSectionEnabled = (section, rights) => {
    let userRights = rights?.length ? rights : [];
    userRights = checkSwitchStatus(userRights, section);
    if (userRights.includes(true)) {
      return TransparentComponent;
    }
    return EmptyComponent;
  };

  const checkIsData = (userRights, section, module) => {
    let updated = [];
    updated = userRights?.length
      ? userRights.map((ele) => {
          if (ele?.rights?.[section]?.length) {
            if (module === 'all') {
              const reqObj = ele.rights[section];
              return reqObj.length ? reqObj[0] : {};
            }
            const reqObj = module ? ele.rights[section].filter((i) => i.module === module) : ele.rights[section];
            return reqObj.length ? reqObj[0] : {};
          }
        })
      : [];

    return updated;
  };

  const isModuleEnabled = (section, module, rights) => {
    let userRights = rights?.length ? rights : [];
    userRights = checkIsData(userRights, section, module);
    userRights = userRights.length ? userRights.map((ele) => ele.switchstatus) : [];
    if (userRights.includes(true)) {
      return TransparentComponent;
    }
    return EmptyComponent;
  };

  const isActionEnabled = (section, module, action, rights) => {
    let userRights = rights?.length ? rights : [];
    userRights = checkIsData(userRights, section, module);
    const _userRights = userRights.length ? userRights.map((ele) => ele?.[action]) : [];
    const allRights = userRights.length ? userRights.map((ele) => ele?.all) : [];

    if (_userRights.includes(true) || allRights.includes(true)) {
      return TransparentComponent;
    }
    return EmptyComponent;
  };

  const getFinalPermission = (userRights, action) => {
    const actionRights = userRights?.length ? userRights.map((ele) => ele[action]) : [];
    const allRights = userRights?.length ? userRights.map((ele) => ele.all) : [];
    return !!(actionRights.includes(true) || allRights.includes(true));
  };

  const getPermissionData = (ele, section, module) => {
    if (ele?.rights?.[section]?.length) {
      if (module === 'all') {
        const reqObj = ele?.rights[section];
        return reqObj.length ? reqObj[0] : {};
      }
      const reqObj = module ? ele.rights[section].filter((i) => i.module === module) : ele.rights[section];
      return reqObj.length ? reqObj[0] : {};
    }
    return {};
  };
  const getPermission = (rights, section, module, action) => {
    let userRights = rights?.length ? rights : [];
    userRights = userRights.length
      ? userRights.map((ele) => {
          return getPermissionData(ele, section, module);
        })
      : [];

    return getFinalPermission(userRights, action);
  };

  const CheckActionPermission = (rights, section, module = null, action = null) => {
    if (userInfo?.role === 'User') {
      return getPermission(rights, section, module, action);
    }
    return true;
  };

  const CheckSectionPermission = (rights, section) => {
    let userRights = rights?.length ? rights : [];
    userRights = checkSwitchStatus(userRights, section);
    return !!userRights.includes(true);
  };

  const CheckModulePermission = (rights, section, module, isAdmin) => {
    let userRights = rights?.length ? rights : [];
    userRights = checkIsData(userRights, section, module);
    userRights = userRights.length ? userRights.map((ele) => ele.switchstatus) : [];

    return isAdmin ? true : !!userRights.includes(true);
  };
  const obj = ['products', 'libraries', 'rangePlan', 'criticalPath', 'planning', 'placeholder', 'supplierOverview', 'manuals', 'masters', 'pim', 'dam', 'dpp'];

  const getAllModulesAccessRights = async (rights) => {
    const userRights = rights?.length ? rights : [];
    const returnObj = {};
    userRights.forEach((ele) => {
      if (ele?.rights) {
        obj.forEach((moduleName) => {
          if (moduleName in ele.rights && ele.rights[moduleName]) {
            const section = ele.rights[moduleName]?.[0]?.section;
            if (section) {
              returnObj[`${moduleName}Access`] = section.switchStatus;
            }
          }
        });
      }
    });
    await dispatch(mainModuleRights(returnObj));
  };

  const getAllSectionAccessRights = async (rights) => {
    const userRights = rights?.length ? rights : [];
    const returnObj = {};
    userRights?.forEach((ele) => {
      obj?.forEach((moduleName) => {
        returnObj[moduleName] = {};
        ele?.rights[moduleName]?.forEach((sectionName) => {
          returnObj[moduleName][`${sectionName.module}Access`] = sectionName?.switchstatus;
        });
      });
    });

    await dispatch(allSectionRights(returnObj));
  };
  const createConditionalComponent = (rights, section, module = null, action = null) => {
    if (userInfo.role === 'User') {
      if (section && module && action) {
        return isActionEnabled(section, module, action, rights);
      }
      if (section && module && action === null) {
        return isModuleEnabled(section, module, rights);
      }
      if (section && module === null && action === null) {
        return isSectionEnabled(section, rights);
      }
      return EmptyComponent;
    }
    return TransparentComponent;
  };

  return {
    createConditionalComponent,
    CheckActionPermission,
    CheckSectionPermission,
    CheckModulePermission,
    getAllModulesAccessRights,
    getAllSectionAccessRights,
  };
};
